/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_TextInputs */



/**
* | output |
* | --- |
* | "Text" |
*
* @param {Transcript_Export_Field_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_text = /** @type {((inputs?: Transcript_Export_Field_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Text")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text")
	if (locale === "it") return /** @type {LocalizedString} */ ("Text")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Text")
	if (locale === "es") return /** @type {LocalizedString} */ ("Text")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Text")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Text")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Text")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Text")
	return /** @type {LocalizedString} */ ("Text")
});